var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { MessageService } from '../../shared/services/message.service';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { DeleteModal } from '../models/delete-modal';
import { CommonMessage } from '../common/common-messages';
import { Constants } from '../common/constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { DataShareService } from '../../shared/services/data.service';
import { SearchModel } from '../interface/ticketingsystem/search.model';
import { environment } from '../../../environments/environment';
import { SearchRequestConstants } from '../common/search-request-constants';
import { TranslateService } from '@ngx-translate/core';
import { Status } from '../enums/ticket-status.enum';
import { DepartmentService } from '../services/department.service';
import { Modal } from 'ngx-modal';
import { CustomerService } from '../services/customer.service';
import { Department } from '../enums/department-type.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ComposeEmailTicketConstants } from '../constants/compose-email.constants';
var FdTicketsComponent = /** @class */ (function () {
    function FdTicketsComponent(_formbuilder, messageService, _cacheService, _commonService, _dataShareService, _translatePipe, departmentService, _customerservice, chRef) {
        this._formbuilder = _formbuilder;
        this.messageService = messageService;
        this._cacheService = _cacheService;
        this._commonService = _commonService;
        this._dataShareService = _dataShareService;
        this._translatePipe = _translatePipe;
        this.departmentService = departmentService;
        this._customerservice = _customerservice;
        this.chRef = chRef;
        this.allTickets = new Array();
        this.excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
        this.rightContentWidth = 1000;
        this.active = true;
        this.tabs = new Array();
        this.existedValues = new Array();
        this.justifyingTabs = false;
        this.fdTickets = new Array();
        this.showAllTickets = true;
        this.ticketTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.assignToOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.countryOnSelectAll = true;
        this.isClearClicked = false;
        this.pageNumber = 1;
        this.pageSize = 25;
        this.pageCount = 0;
        this.isDesc = true;
        this.pageSizes = [10, 25, 50, 75];
        this.sortColumn = 'TICKET_NUMBER';
        this.sort = 'DESC';
        this.selectedCountries = [];
        this.disputeSearch = false;
        this.selectedTickets = new Array();
        this.selectAll = false;
        this.ticketsOnSelectAll = new Array();
        this.message = '';
        this.closed = 0;
        this.activetab = 1;
        /** * Pagination instance - to avoid console warnings - inorder to assign id for pagination */
        this.paginationInstance = {
            id: 'fd-tickets-pagination',
            itemsPerPage: 10,
            currentPage: 1
        };
        this.dropdownSettings = {
            typeDropdownList: [],
            typeSelectedItems: [],
            typeIndex: 2,
            subTypeDropdownList: [],
            subTypeSelectedItems: [],
            subTypeIndex: 3,
            statusDropdownList: [],
            statusSelectedItems: [],
            statusIndex: 4,
            departmentDropdownList: [],
            departmentSelectedItems: [],
            departmentIndex: 6,
            assignedToDropdownList: [],
            assignedToSelectedItems: [],
            assignedToIndex: 7,
            countryDropdownList: [],
            countrySelectedItems: [],
            countryIndex: 8,
            settings: {},
        };
        this.countryDropdownSettings = {
            singleSelection: false,
            text: 'select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            enableSearchFilter: false,
            classes: 'myclass custom-class',
            badgeShowLimit: 1,
        };
    }
    FdTicketsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        this.buildSpamForm();
        this.intializeMultiselectDropdowns();
        this.dropdownSettings.settings = {
            singleSelection: false,
            text: 'select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            enableSearchFilter: false,
            classes: 'myclass custom-class',
            badgeShowLimit: 1,
        };
        this.tabModel = new ViewTabModel();
        this.fieldTypes = new SearchRequestConstants();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_TICKETS_VIEW + ']'), AccessLevel.Customer_Service);
        this.assignedToId = this.userInfo.userId;
        this.active = false;
        this.overDueDisable = false;
        this.ticketSearchModel = new SearchModel();
        this.countryId = this.getAllowedCountries();
        this.ticketSearchModel.overDueCount = false;
        this.showAllTickets = false;
        this._dataShareService.customerServiceMessage.subscribe(function (message) {
            if (message && message !== '') {
                var splittedMessage = message.split('-');
                _this.rightContentWidth = Number(splittedMessage[0]);
            }
        });
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.isDiputeTicketSearch ? (this.disputeSearch = true) : '';
        this.closed = Status.Closed;
        if (this.userInfo.privileges.departments && !this.userInfo.hasSystemRole) {
            this.userDepartments = this.userInfo.privileges.departments.map(function (a) { return a.id; });
        }
        this.getTicketStatus();
        this.getOperatingCountries(true);
    };
    /**initialize the form */
    FdTicketsComponent.prototype.buildForm = function () {
        this.unAssinged = true;
        this.fdTicketsForm = this._formbuilder.group({
            ticketNumber: [''],
            operatingCountryId: [''],
            assignTo: [''],
            type: [''],
            subType: [''],
            status: [''],
            email: ['', [Validators.pattern(ComposeEmailTicketConstants.EMAIL_REGEXP)]]
        });
    };
    /**  Build form for bulk spam*/
    FdTicketsComponent.prototype.buildSpamForm = function () {
        this.ticketSpamOrUnspamForm = this._formbuilder.group({
            ticketId: ['', Validators.required],
        });
    };
    /**reset spam ticket */
    FdTicketsComponent.prototype.resetTicketSpamOrUnspamForm = function () {
        this.ticketSpamOrUnspamForm.reset();
        this.isFormInvalid = false;
        this.selectedTickets = [];
        this.ticketSpamOrUnspamForm.controls['ticketId'].setValue('');
    };
    /**initialize  property values for mutltiselect dropdown */
    FdTicketsComponent.prototype.intializeMultiselectDropdowns = function () {
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.statusDropdownList = [];
        this.dropdownSettings.statusSelectedItems = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.assignedToDropdownList = [];
        this.dropdownSettings.assignedToSelectedItems = [];
        this.dropdownSettings.countrySelectedItems = [];
        this.dropdownSettings.settings = {
            text: 'Select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            classes: 'myclass custom-class',
            badgeShowLimit: 1,
        };
    };
    /** get allowed country ids */
    FdTicketsComponent.prototype.getAllowedCountries = function () {
        var countryIds = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(',');
                countryIds.sort(function (id1, id2) {
                    if (id1 < id2) {
                        return -1;
                    }
                    if (id1 > id2) {
                        return 1;
                    }
                    return 0;
                });
                return countryIds[0];
            }
        }
        return OperatingCountryEnums.USA;
    };
    FdTicketsComponent.prototype.subscribeTabContent = function () {
        var _this = this;
        this.messageService.getCustomerServiceTabContent().subscribe(function (data) {
            if (data) {
                _this.id = data.id;
                _this.tabTitle = data.tabName;
                _this.componentName = data.componentName;
                _this.addNewTab();
                _this.justifyingTabs = (_this.tabs && _this.tabs.length) ? true : false;
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                _this.messageService.setOpenTabsInfo((_this.tabs && _this.tabs.length) ? true : false);
            }
        });
    };
    FdTicketsComponent.prototype.addNewTab = function () {
        this.tabModel = new ViewTabModel();
        this.tabModel.id = this.id;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.tabModel.componentName = this.componentName;
        this.existedValues = new Array();
        var index = this.tabs.map(function (el) {
            return el.id;
        }).indexOf(this.id);
        if (this.tabs.length === Constants.MaximumTabsLength) {
            // need to display information -- as you reached maxiumum number of tabs.
            this.displayAlertBoxOnReachingMaxTabs();
        }
        else {
            if (index < 0) {
                this.tabs.push(this.tabModel);
            }
            else {
                var selectedId_1 = this.id;
                this.tabs.forEach(function (x) {
                    if (x.id !== selectedId_1) {
                        x.active = false;
                    }
                    else {
                        x.active = true;
                    }
                });
            }
        }
    };
    /*** display alert box on reaching maximum no of tabs = 8*/
    FdTicketsComponent.prototype.displayAlertBoxOnReachingMaxTabs = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsMessage;
    };
    /*** To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs*/
    FdTicketsComponent.prototype.subscribeClosedTabs = function () {
        var _this = this;
        this.messageService.getCloseTabsEvent().subscribe(function (data) {
            if (data) {
                _this.closeAllOpenedTabs();
            }
        });
    };
    /** * Close all opened tabs */
    FdTicketsComponent.prototype.closeAllOpenedTabs = function () {
        this.tabs = []; //new Array<DynamicTabModel>();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
    };
    /** get status types */
    FdTicketsComponent.prototype.getTicketStatus = function () {
        var _this = this;
        if (this.statusTypes) {
            this.statusTypes.sort(function (item1, item2) {
                var status1 = item1.value.toLowerCase(), status2 = item2.value.toLowerCase();
                if (status1 < status2) {
                    return -1;
                }
                if (status1 > status2) {
                    return 1;
                }
                return 0;
            });
            this.dropdownSettings.statusSelectedItems = [];
            this.statusTypes.forEach(function (item) {
                _this.dropdownSettings.statusDropdownList.push({ id: item.id, itemName: item.value });
                if (item.id === Status.InProgress || item.id === Status.New || item.id === Status.OnHold) {
                    _this.dropdownSettings.statusSelectedItems.push({ id: item.id, itemName: item.value });
                }
                _this.statusOnSelectAll = false;
            });
        }
    };
    /** * get operating countries */
    FdTicketsComponent.prototype.getOperatingCountries = function (onLoad) {
        if (onLoad && this.operatingCountries && this.operatingCountries.length > 0) {
            this.loadCountries(onLoad);
        }
        else {
            this.loadOpCoAndDep(true);
        }
    };
    FdTicketsComponent.prototype.sortOpCo = function () {
        var _this = this;
        var countryInfo = this.operatingCountries.find(function (country) { return country.id === _this.countryId; });
        if (countryInfo) {
            this.operatingCountries.splice(this.operatingCountries.indexOf(countryInfo), 1);
            this.operatingCountries.splice(0, 0, countryInfo);
        }
        this.sortingtypes(this.dropdownSettings.countryDropdownList);
    };
    FdTicketsComponent.prototype.loadCountries = function (onLoad) {
        var _this = this;
        this.dropdownSettings.countryDropdownList = [];
        this.dropdownSettings.countrySelectedItems = [];
        this.departments = this.allDepartment ? this.allDepartment : [];
        var FDdepartments = this.departments.filter(function (data) { return data.value.toLowerCase().trim() == Department.FD.toLowerCase().trim(); });
        FDdepartments.forEach(function (FDdata) {
            _this.operatingCountries.forEach(function (countries) {
                if (countries.id == FDdata.customId) {
                    _this.dropdownSettings.countryDropdownList.push({ id: countries.id, itemName: countries.name.trim() });
                }
            });
        });
        this.sortOpCo();
        this.fdOperatingCountries = this.dropdownSettings.countryDropdownList;
        this.dropdownSettings.countrySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.countryDropdownList));
        this.countryOnSelectAll = true;
        this.iterateticket(onLoad);
    };
    /** get ticket type and subtype* if(true) then get api call* */
    FdTicketsComponent.prototype.iterateticket = function (load) {
        var _this = this;
        if (load) {
            var fdDepartments = this.departments.filter(function (data) { return data.value.toLowerCase().trim() == Department.FD.toLowerCase().trim(); });
            var fdIds = fdDepartments.map(function (department) { return department.id; });
            this.fdDepartmentId = fdIds.slice();
            var reqs = [];
            reqs.push(this.departmentService.getTicketTypesAndSubTypes().pipe(catchError(function (err) {
                return of({ isError: true });
            })));
            if (fdIds && fdIds.length > 0) {
                reqs.push(this._customerservice.getAssignedUsersByDepartmentIds(fdIds).pipe(catchError(function (err) {
                    return of({ isError: true });
                })));
            }
            if (reqs.length > 0) {
                forkJoin(reqs).subscribe(function (response) {
                    if (response && response.length > 0) {
                        _this.ticketTypes = response[0] && Array.isArray(response[0]) ? response[0] : [];
                        _this.allTicketTypes = response[0] ? response[0] : [];
                        _this.populateTypeSubtype(_this.allTicketTypes, true);
                        _this.assignedUsers = response[1] ? response[1] : [];
                        _this.populateAssignedUsers(_this.assignedUsers, true);
                    }
                    else {
                        _this.assignEmptyToTypeandSubType();
                    }
                }, function (error) {
                    _this.assignEmptyToTypeandSubType();
                });
            }
        }
        else {
            this.getDepartmentByCountry();
        }
    };
    /**
   *
   * @param allTypes filter type and subtypes based on all tickect types
   */
    FdTicketsComponent.prototype.populateTypeSubtype = function (allTypes, onLoad) {
        this.assignEmptyToTypeandSubType();
        if (allTypes.length > 0 && !allTypes.isError && !this.isDiputeTicketSearch) {
            this.ticketTypes = allTypes;
            this.iterateList(this.ticketTypes);
            this.sortingtypes(this.dropdownSettings.typeDropdownList);
            this.sortingtypes(this.dropdownSettings.subTypeDropdownList);
            this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));
            this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.subTypeDropdownList));
            this.ticketTypeOnSelectAll = true;
            this.subTypeOnSelectAll = true;
        }
        else if (allTypes.length > 0 && !allTypes.isError && this.isDiputeTicketSearch) {
            this.ticketTypes = allTypes;
            this.iterateList(this.ticketTypes);
            this.sortingtypes(this.dropdownSettings.typeDropdownList);
            this.sortingtypes(this.dropdownSettings.subTypeDropdownList);
            this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));
            this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.subTypeDropdownList));
            this.ticketTypeOnSelectAll = true;
            this.subTypeOnSelectAll = true;
        }
        else if (allTypes.isError == true) {
            this.assignEmptyToTypeandSubType();
            this.ticketTypeOnSelectAll = false;
            this.subTypeOnSelectAll = false;
        }
        else if ((allTypes.length === 0 || this.allTicketTypes.length === 0) && !onLoad) {
            this.iterateticket(true);
            this.ticketTypeOnSelectAll = false;
            this.subTypeOnSelectAll = false;
        }
        else {
            this.ticketTypeOnSelectAll = false;
            this.subTypeOnSelectAll = false;
        }
    };
    FdTicketsComponent.prototype.iterateList = function (allTypes) {
        var _this = this;
        var tickets = allTypes.filter(function (type) { return (_this.dropdownSettings.countrySelectedItems.find(function (countries) { return countries.id == type.operatingCountry; })); });
        tickets.forEach(function (item) {
            var operatingCountryName;
            if (item.operatingCountryName !== null) {
                operatingCountryName = item.operatingCountryName.trim();
            }
            var ticketType = operatingCountryName + ' ' + '-' + ' ' + item.value.trim();
            _this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: ticketType });
            item.subTypes.forEach(function (subType) {
                var subTypeName = operatingCountryName + ' ' + '-' + ' ' + subType.name.trim();
                _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
            });
        });
    };
    /**
     *
     * @param allUsers assign required user based on availabe countries
     */
    FdTicketsComponent.prototype.populateAssignedUsers = function (allUsers, onLoad) {
        var _this = this;
        this.dropdownSettings.assignedToDropdownList = [];
        this.dropdownSettings.assignedToSelectedItems = [];
        if (allUsers.length > 0 && !allUsers.isError) {
            this.users = allUsers;
            this.users = this.users.filter(function (item) { return item.id !== 1; });
            this.users.forEach(function (item) {
                _this.dropdownSettings.assignedToDropdownList.push({
                    id: item.id,
                    itemName: item.name.trim(),
                });
            });
            this.sortingtypes(this.dropdownSettings.assignedToDropdownList);
            this.dropdownSettings.assignedToSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.assignedToDropdownList));
            this.assignToOnSelectAll = true;
            if (onLoad) {
                this.onSearch();
            }
        }
        else if (allUsers.length === 0 || allUsers.isError == true) {
            this.users = [];
            this.dropdownSettings.assignedToDropdownList = [];
            this.dropdownSettings.assignedToSelectedItems = [];
            this.assignToOnSelectAll = false;
        }
    };
    /**
   * set empty values to type and subtype
   */
    FdTicketsComponent.prototype.assignEmptyToTypeandSubType = function () {
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.typeSelectedItems = [];
    };
    FdTicketsComponent.prototype.loadOpCoAndDep = function (onLoad) {
        var _this = this;
        var reqs = [];
        reqs.push(this._customerservice.getAllBusinessEntities().pipe(catchError(function (err) {
            return of({ isError: true });
        })));
        reqs.push(this._customerservice.getDepartments().pipe(catchError(function (err) {
            return of({ isError: true });
        })));
        if (reqs.length > 0) {
            forkJoin(reqs).subscribe(function (response) {
                if (response && response.length > 0) {
                    _this.operatingCountries = response[0] && Array.isArray(response[0]) ? response[0] : [];
                    _this.allDepartment = response[1] && Array.isArray(response[1]) ? response[1] : [];
                    var departmentIds_1 = _this.userInfo.privileges.departments.map(function (a) { return a.id; }) ? _this.userInfo.privileges.departments.map(function (a) { return a.id; }) : [];
                    var FdDepartments = _this.allDepartment ? _this.allDepartment.filter(function (dept) { return dept.value.toLowerCase() == Department.FD.toLowerCase().trim(); }) : [];
                    if (_this.operatingCountries && _this.operatingCountries.length > 0 && _this.allDepartment && _this.allDepartment.length > 0) {
                        if (_this.userInfo.hasSystemRole && FdDepartments.length > 0) {
                            _this.allDepartment = _this.allDepartment;
                            _this.getOperatingCountries(true);
                        }
                        else if (!_this.userInfo.hasSystemRole && departmentIds_1 && departmentIds_1.length > 0) {
                            _this.allDepartment = _this.allDepartment.filter(function (item) { return departmentIds_1.indexOf(item.id) != -1 && item.value.toLowerCase() === Department.FD.toLowerCase(); });
                            _this.getOperatingCountries(true);
                        }
                    }
                }
                else {
                    _this.operatingCountries = [];
                    _this.allDepartment = [];
                }
            }, function (error) {
                _this.operatingCountries = [];
                _this.allDepartment = [];
            });
        }
        else {
            this.operatingCountries = [];
            this.allDepartment = [];
        }
    };
    FdTicketsComponent.prototype.getDepartmentByCountry = function () {
        var _this = this;
        clearTimeout(this.departmentTimeoutID);
        this.departmentTimeoutID = setTimeout(function () {
            _this.populateTypeSubtype(_this.allTicketTypes, false);
            var deptArr = _this.departments.filter(function (dept) {
                return dept.value.toLowerCase() === Department.FD.toLowerCase() &&
                    dept.customId === (_this.dropdownSettings.countrySelectedItems.find(function (country) { return country.id === dept.customId; })
                        ? _this.dropdownSettings.countrySelectedItems.find(function (country) { return country.id === dept.customId; }).id : null);
            });
            _this.dropdownSettings.departmentSelectedItems = [];
            deptArr.forEach(function (item) {
                _this.dropdownSettings.departmentSelectedItems.push({ id: item.id, itemName: item.value });
            });
            _this.getAssignedUsersByDepartments(_this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }), false);
        }, 0);
    };
    FdTicketsComponent.prototype.getAssignedUsersByDepartments = function (departmentIds, onLoad) {
        var _this = this;
        if (departmentIds && departmentIds.length > 0) {
            this.dropdownSettings.assignedToDropdownList = [];
            this.dropdownSettings.assignedToSelectedItems = [];
            this.fdDepartmentId = departmentIds.slice();
            this._customerservice.getAssignedUsersByDepartmentIds(departmentIds).subscribe(function (response) {
                if (response) {
                    _this.users = response;
                    _this.users = _this.users.filter(function (item) { return item.id !== 1; });
                    _this.users.forEach(function (item) {
                        _this.dropdownSettings.assignedToDropdownList.push({
                            id: item.id, itemName: item.name.trim(),
                        });
                    });
                    _this.sortingtypes(_this.dropdownSettings.assignedToDropdownList);
                    _this.dropdownSettings.assignedToSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.assignedToDropdownList));
                    _this.assignToOnSelectAll = true;
                    if (onLoad) {
                        _this.onSearch();
                    }
                }
                else {
                    _this.users = [];
                    _this.dropdownSettings.assignedToDropdownList = [];
                    _this.dropdownSettings.assignedToSelectedItems = [];
                }
            });
        }
    };
    /**
  * @description To Search Tickets
  * @date 2020-01-31
  * @param {boolean} [tabChange]
  * @memberof FormTicketsComponent
  */
    FdTicketsComponent.prototype.onSearch = function (tabChange) {
        var searchBtn = document.getElementById('search-button');
        if (searchBtn) {
            searchBtn.classList.add('button-active');
            setTimeout(function () {
                searchBtn.classList.remove('button-active');
            }, 1000);
        }
        if (!tabChange) {
            this.pageNumber = 1;
        }
        else {
            this.pageNumber = isNaN(this.pageNumber) ? 1 : this.pageNumber;
        }
        if (this.dropdownSettings.countrySelectedItems && this.dropdownSettings.countrySelectedItems.length > 0) {
            this.getTicketsSearch(false);
        }
    };
    FdTicketsComponent.prototype.getTicketsSearch = function (fetchAllrecords, isClearSelectedItems) {
        var _this = this;
        if (this.fdTicketsForm.valid && !(this.fdTicketsForm.get('ticketNumber').value && this.fdTicketsForm.get('email').value)) {
            if (isClearSelectedItems) {
                this.selectAll = false;
                this.selectedTickets = [];
            }
            if (this.isAllSelectedTicketsSpamedOrUnspamed) {
                this.resetTicketSpamOrUnspamForm();
                this.isAllSelectedTicketsSpamedOrUnspamed = false;
            }
            if (!(this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length > 0)) {
                this.dropdownSettings.statusSelectedItems.push({ id: Status.InProgress, itemName: Status[Status.InProgress] });
                this.statusOnSelectAll = false;
            }
            this.selectedTickets = [];
            this.isFormInvalid = false;
            this._customerservice.SearchTicketsOnPagination(null, (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.assignedToSelectedItems.map(function (item) { return item.id; }) : []), this.ticketSearchModel.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), null, (this.fdDepartmentId && this.fdDepartmentId.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.fdDepartmentId : []), (this.dropdownSettings.statusSelectedItems.map(function (item) { return item.id; })), null, this.pageNumber ? this.pageNumber : 1, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.ticketSearchModel.overDueCount, !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.unAssinged : null, this.fdTicketsForm.get('email').value ? this.fdTicketsForm.get('email').value : null, this.fdTicketsForm.get('email').value && this.fdTicketsForm.get('operatingCountryId').value.length > 0 ? this.fdTicketsForm.get('operatingCountryId').value.map(function (country) { return country.id; }) : null, null, null, false)
                .subscribe(function (response) {
                if (response) {
                    _this.pageCount = response['totalCount'];
                    _this.allTickets = response['content'];
                    _this.fdTickets = response['content'];
                    if (_this.fdTickets && _this.fdTickets.length) {
                        _this.fdTickets.forEach(function (x) {
                            if (x.dueDate) {
                                x.dueDate = moment.utc(x.dueDate).utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.createdDate) {
                                x.createdDate = moment.utc(x.createdDate).utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.modifiedDate) {
                                x.modifiedDate = moment.utc(x.modifiedDate).utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (_this.selectedTickets.find(function (ticket) { return ticket.id === x.id; })) {
                                x.isSelected = true;
                            }
                            if (x.operatingCountryId) {
                                x.operatingCountryId = _this.operatingCountries.find(function (ticket) { return x.operatingCountryId === ticket.id; }).name;
                            }
                        });
                        _this.selectAll = _this.fdTickets.every(function (ticket) { return ticket.isSelected === true; });
                    }
                    _this.selectedCountries = _this.ticketSearchModel.ticketNumber ? [] : _this.dropdownSettings.countrySelectedItems;
                }
                else {
                    _this.pageCount = 0;
                    _this.allTickets = [];
                    _this.fdTickets = [];
                }
            });
            this.setFocusToTextBox();
        }
    };
    FdTicketsComponent.prototype.onItemSelect = function (item, indexValue) {
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.statusTypes.length === this.dropdownSettings.statusSelectedItems.length) {
                this.statusOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            if (this.dropdownSettings.subTypeDropdownList.length === this.dropdownSettings.subTypeSelectedItems.length) {
                this.subTypeOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            this.unAssinged = false;
            if (this.users.length === this.dropdownSettings.assignedToSelectedItems.length) {
                this.assignToOnSelectAll = true;
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.countryIndex === +indexValue) {
            this.countryOnSelectAll = false;
            if (this.fdOperatingCountries.length === this.dropdownSettings.countrySelectedItems.length) {
                this.countryOnSelectAll = true;
            }
            this.iterateticket(false);
        }
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                this.iterateSubTypes();
                this.ticketTypeOnSelectAll = false;
                if (this.dropdownSettings.typeDropdownList.length === this.dropdownSettings.typeSelectedItems.length) {
                    this.ticketTypeOnSelectAll = true;
                }
                else {
                    this.ticketTypeOnSelectAll = false;
                }
            }
        }
    };
    FdTicketsComponent.prototype.onItemDeSelect = function (item, indexValue) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                this.iterateSubTypes();
                this.ticketTypeOnSelectAll = false;
            }
            else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
            }
        }
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.showAllTickets) {
                this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
                this.statusOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            this.unAssinged = false;
            if (this.dropdownSettings.assignedToSelectedItems.length === 0) {
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.countryIndex === +indexValue) {
            this.countryOnSelectAll = false;
            this.iterateticket(false);
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.sortingtypes(this.dropdownSettings.subTypeDropdownList);
        }
    };
    FdTicketsComponent.prototype.onSelectAll = function (items, indexValue) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.iterateSubTypes();
            this.ticketTypeOnSelectAll = true;
        }
        else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = true;
            this.unAssinged = true;
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = true;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = true;
        }
        else if (this.dropdownSettings.countryIndex === +indexValue) {
            this.countryOnSelectAll = true;
            this.iterateticket(false);
        }
    };
    FdTicketsComponent.prototype.onDeSelectAll = function (items, indexValue) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.ticketTypeOnSelectAll = false;
        }
        else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            if (this.dropdownSettings.assignedToSelectedItems.length === 0) {
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
        }
        else if (this.dropdownSettings.countryIndex === +indexValue) {
            this.countryOnSelectAll = false;
            this.assignToOnSelectAll = false;
            this.dropdownSettings.assignedToSelectedItems = [];
            this.iterateticket(false);
        }
    };
    FdTicketsComponent.prototype.iterateSubTypes = function () {
        var _this = this;
        var selectedIds = this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.ticketTypes.filter(function (item) { return selectedIds.some(function (index) { return index === item.id; }); }).forEach(function (type) {
            type.subTypes.forEach(function (subType) {
                _this.dropdownSettings.subTypeDropdownList.push({
                    id: subType.id,
                    itemName: type.operatingCountryName + ' ' + '-' + ' ' + subType.name.trim(),
                });
            });
        });
        this.sortingtypes(this.dropdownSettings.subTypeDropdownList);
    };
    FdTicketsComponent.prototype.sortingtypes = function (data) {
        if (data.length > 0) {
            data.sort(function (item1, item2) {
                var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                if (tickettype1 < tickettype2) {
                    return -1;
                }
                if (tickettype1 > tickettype2) {
                    return 1;
                }
                return 0;
            });
        }
    };
    /*
    on change of check box in tickets grid
    */
    FdTicketsComponent.prototype.onTicketSelect = function (event, fdTickets, isAllSelected) {
        this.isFormInvalid = false;
        if (event.target.checked) {
            if (fdTickets.length) {
                for (var _i = 0, fdTickets_1 = fdTickets; _i < fdTickets_1.length; _i++) {
                    var ticket = fdTickets_1[_i];
                    if (!ticket.isSelected) {
                        ticket.isSelected = true;
                        this.ticketSpamOrUnspamForm.controls['ticketId'].setValue(ticket.id);
                        this.selectedTickets.push({
                            id: ticket.id,
                            ticketNumber: ticket.ticketNumber,
                        });
                    }
                }
                this.selectAll = this.fdTickets.every(function (ticket) { return ticket.isSelected === true; });
            }
        }
        else {
            if (fdTickets.length) {
                for (var _a = 0, fdTickets_2 = fdTickets; _a < fdTickets_2.length; _a++) {
                    var ticket = fdTickets_2[_a];
                    ticket.isSelected = false;
                    this.selectedTickets.splice(this.selectedTickets.map(function (ticket) { return ticket.id; }).indexOf(ticket.id), 1);
                }
                this.selectAll = this.fdTickets.every(function (ticket) { return ticket.isSelected === true; });
            }
        }
    };
    /* To spam or unspam the selected tickets */
    FdTicketsComponent.prototype.spamorUnspamSelectedTickets = function () {
        var _this = this;
        var listOfTicketsToBeSpamed = [];
        var spamOrUnspamReason;
        var isSpam;
        if (this.dropdownSettings.statusSelectedItems.length === 1 && this.dropdownSettings.statusSelectedItems[0].id === Status.Closed) {
            isSpam = false;
            spamOrUnspamReason = this._translatePipe.get('validation-message.Ticket is marked as unspam');
        }
        else {
            isSpam = true;
            spamOrUnspamReason = this._translatePipe.get('validation-message.Ticket is marked as spam');
        }
        this.selectedTickets.forEach(function (ticket) {
            listOfTicketsToBeSpamed.push({
                id: ticket.id,
                ticketNumber: ticket.ticketNumber,
                updatedBy: _this.userInfo.userId,
                closeOtherReason: spamOrUnspamReason.value,
            });
        });
        this._customerservice.markATicketorAllTicketsAsSpamOrUnpsam(listOfTicketsToBeSpamed, isSpam).subscribe(function (response) {
            if (response) {
                var success = void 0;
                if (isSpam) {
                    success = _this._translatePipe.get('success-message.Ticket(s) marked as spam and closed successfully');
                }
                else {
                    success = _this._translatePipe.get('success-message.Ticket(s) marked as not spam successfully');
                }
                _this._commonService.createNotification('', success.value, NotificationType.SUCCESS);
                _this.isAllSelectedTicketsSpamedOrUnspamed = true;
                if (_this.selectAll) {
                    _this.pageNumber = _this.pageNumber - 1;
                }
                _this.selectAll = false;
                _this.getTicketsSearch(false);
            }
            else {
                var failed = void 0;
                if (isSpam) {
                    failed = _this._translatePipe.get('error-message.Tickets couldn\'t be marked as spam');
                }
                else {
                    failed = _this._translatePipe.get('error-message.Tickets couldn\'t be marked as unspam');
                }
                _this._commonService.createNotification('', failed.value, NotificationType.ERROR);
                _this.unselectTicketsWhenSpamOrUnspamFailed();
                _this.isAllSelectedTicketsSpamedOrUnspamed = true;
                _this.resetTicketSpamOrUnspamForm();
            }
        }, function (error) {
            var unknown = _this._translatePipe.get('validation-message.Unknown Error');
            _this.message = error != null && error[0] != null
                ? error[0].field + ' : ' + error[0].message
                : unknown.value;
            _this._commonService.createNotification('', _this.message, NotificationType.ERROR);
            _this.unselectTicketsWhenSpamOrUnspamFailed();
            _this.isAllSelectedTicketsSpamedOrUnspamed = true;
            _this.resetTicketSpamOrUnspamForm();
        });
        this.spamOrUnspamTicketConfirmation.close();
    };
    FdTicketsComponent.prototype.selectTicketAsSpamOrUnspam = function (ticketSpamOrUnspamForm) {
        if (this.ticketSpamOrUnspamForm.valid && ticketSpamOrUnspamForm) {
            if (!this.selectedTickets || this.selectedTickets.length === 0) {
                this.isFormInvalid = true;
                return;
            }
            else {
                this.openSpamOrUnspamTicketConfirmationPopup();
            }
        }
        else {
            this.isFormInvalid = true;
        }
    };
    FdTicketsComponent.prototype.closeSpamOrUnpsamTicketConfirmationPopup = function () {
        this.spamOrUnspamTicketConfirmation.close();
    };
    FdTicketsComponent.prototype.openSpamOrUnspamTicketConfirmationPopup = function () {
        this.spamOrUnspamTicketConfirmation.open();
    };
    FdTicketsComponent.prototype.unselectTicketsWhenSpamOrUnspamFailed = function () {
        var _this = this;
        this.selectedTickets.forEach(function (selectedTicket) {
            _this.fdTickets.forEach(function (myTicket) {
                if (selectedTicket.id === myTicket.id) {
                    myTicket.isSelected = false;
                }
            });
        });
    };
    FdTicketsComponent.prototype.setFocusToTextBox = function () {
        setTimeout(function () {
            var element = document.getElementById('ticketType');
            var email = document.getElementById('email');
            if (element.value) {
                element.focus();
            }
            else if (email.value) {
                email.focus();
            }
            else {
                element.focus();
            }
        }, 1000);
    };
    FdTicketsComponent.prototype.searchWithTicketNumber = function () {
        if (this.ticketSearchModel.ticketNumber) {
            this.countryDropdownSettings = __assign({}, this.dropdownSettings.settings, { disabled: true });
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: true });
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList.slice();
            this.OnTabSearchFocus();
            this.chRef.detectChanges();
        }
        else if (this.fdTicketsForm.get('email').value) {
            this.countryDropdownSettings = __assign({}, this.dropdownSettings.settings, { disabled: false });
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: true });
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList.slice();
            this.OnTabSearchFocus();
            this.chRef.detectChanges();
        }
        else {
            this.countryDropdownSettings = __assign({}, this.dropdownSettings.settings, { disabled: false });
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: false });
            this.chRef.detectChanges();
        }
    };
    FdTicketsComponent.prototype.OnTabSearchFocus = function () {
        var element = document.getElementById('search-button');
        if (element) {
            if (this.fdTicketsForm.get('ticketNumber').value != "")
                element.focus();
        }
        event.preventDefault();
    };
    FdTicketsComponent.prototype.selectTab = function (tab) {
        this.activetab = tab;
    };
    FdTicketsComponent.prototype.goToViewTicket = function (id, ticketNumber) {
        if (this.isTicketView) {
            var ticketTab = new TicketTabInfo();
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = 'View Ticket - ' + ticketNumber;
            ticketTab.viewTicket = true;
            ticketTab.isFdTicket = true;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
    };
    /**
     * display alert box if the logged in user do not have permission to see the fbo/retail information
     */
    FdTicketsComponent.prototype.displayAlertbox = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    };
    FdTicketsComponent.prototype.doNotRemoveFormData = function () {
        //data should not be removed...
    };
    FdTicketsComponent.prototype.openDropDown = function (element) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute('hidden');
    };
    FdTicketsComponent.prototype.onDropDowneBlur = function (element) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute('hidden', 'true');
    };
    /*form data to download to pdf/ csv/print*/
    FdTicketsComponent.prototype.Download = function (type) {
        var _this = this;
        var columns = [
            this._translatePipe.get('ticketing-system.Priority')['value'],
            this._translatePipe.get('ticketing-system.Ticket#')['value'],
            this._translatePipe.get('ticketing-system.Subject')['value'],
            this._translatePipe.get('ticketing-system.Country')['value'],
            this._translatePipe.get('ticketing-system.User')['value'],
            this._translatePipe.get('ticketing-system.Type')['value'],
            this._translatePipe.get('ticketing-system.Subtype')['value'],
            this._translatePipe.get('ticketing-system.Status')['value'],
            this._translatePipe.get('ticketing-system.Created Date')['value'],
            this._translatePipe.get('ticketing-system.Last Modified Date')['value']
        ];
        var rowdata = new Array();
        var finalrows = new Array();
        this._customerservice.SearchTicketsOnPagination(null, (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.assignedToSelectedItems.map(function (item) { return item.id; }) : []), this.ticketSearchModel.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), null, (this.fdDepartmentId && this.fdDepartmentId.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.fdDepartmentId : []), (this.dropdownSettings.statusSelectedItems.map(function (item) { return item.id; })), null, this.pageNumber ? this.pageNumber : 1, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.ticketSearchModel.overDueCount, !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.unAssinged : null, this.fdTicketsForm.get('email').value ? this.fdTicketsForm.get('email').value : null, this.fdTicketsForm.get('email').value && this.fdTicketsForm.get('operatingCountryId').value.length > 0 ? this.fdTicketsForm.get('operatingCountryId').value.map(function (country) { return country.id; }) : null, null, null, true)
            .subscribe(function (response) {
            if (response && response['content']) {
                var tickets = response['content'];
                for (var i = 0; i < tickets.length; i++) {
                    rowdata = [];
                    var a1 = tickets[i];
                    rowdata.push(a1.priorityValue);
                    rowdata.push('\t' + a1.ticketNumber);
                    rowdata.push(a1.subject);
                    rowdata.push(a1.operatingCountryName);
                    rowdata.push(a1.assignedToValue ? a1.assignedToValue : '');
                    rowdata.push(a1.ticketType);
                    rowdata.push(a1.subType);
                    rowdata.push(a1.status);
                    rowdata.push(a1.createdDate ? moment.utc(a1.createdDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                    rowdata.push(a1.modifiedDate ? moment.utc(a1.modifiedDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                    finalrows.push(rowdata);
                }
                var title = _this._translatePipe.get('ticketing-system.FD Tickets')['value'];
                _this._customerservice.ExcelDownload(columns, finalrows, 'FD Tickets', title);
            }
        });
    };
    /**
       * sort table by respective column
       * @param sortColumn
       */
    FdTicketsComponent.prototype.sortTableByColumn = function (sortColumn) {
        this.isDesc = this.sortColumn === sortColumn ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? 'DESC' : 'ASC';
        this.sortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.fdTickets.length === 0) {
            return;
        }
        this.getTicketsSearch(false);
    };
    /**
     * On Page change
     * @param pageNumber
     */
    FdTicketsComponent.prototype.pageChange = function (pageNumber) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.getTicketsSearch(false);
        }
    };
    FdTicketsComponent.prototype.clearFields = function () {
        this.resetContent();
    };
    FdTicketsComponent.prototype.resetContent = function () {
        this.intializeMultiselectDropdowns();
        this.setFocusToTextBox();
        this.fdTicketsForm.get('email').setValue('');
        this.ticketSearchModel = new SearchModel();
        this.ticketSearchModel.ticketNumber = '';
        this.ticketSearchModel.overDueCount = false;
        this.tabModel = new ViewTabModel();
        this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: false });
        this.countryDropdownSettings = __assign({}, this.dropdownSettings.settings, { disabled: false });
        this.isDiputeTicketSearch ? (this.disputeSearch = true) : '';
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.countryId = this.getAllowedCountries();
        this.active = false;
        this.showAllTickets = false;
        this.fieldTypes = new SearchRequestConstants();
        this.assignedToId = this.userInfo.userId;
        this.overDueDisable = false;
        this.closed = Status.Closed;
        if (this.userInfo.privileges.departments && !this.userInfo.hasSystemRole) {
            this.userDepartments = this.userInfo.privileges.departments.map(function (a) { return a.id; });
        }
        this.resetTicketSpamOrUnspamForm();
        if (this.isClearClicked) {
            this.isClearClicked = false;
            this.getTicketStatus();
            this.getOperatingCountries(true);
        }
    };
    return FdTicketsComponent;
}());
export { FdTicketsComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/fd-tickets.component.ts.pre-build-optimizer.js